<script>
export default {
  name: 'AuthLayout',
  components: {
    AuthMag: () => import('./AuthMag/AuthMag.layout.vue'),
  },
  computed: {
    name() {
      return 'AuthMag';
    },
  },
};
</script>
<template>
  <component :is="name"></component>
</template>
